import React, {FC, PropsWithChildren, useContext, useEffect} from "react";
import {Navigate} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";
import {isPortalToken, PORTAL_HOME} from "../helpers/PortalSignInHelper";

const NotLoggedInGuard: FC<PropsWithChildren> = ({children}) => {
    const {Token} = useContext(AuthContext);
    const portal = isPortalToken(Token);

    // Customer ticket portal accounts have nothing in the classic web; their tickets live in /app.
    useEffect(() => {
        if (portal) window.location.replace(PORTAL_HOME);
    }, [portal]);

    if (!Token) {
        const loggingOut = sessionStorage.getItem("loggingOut");
        if (loggingOut) {
            sessionStorage.clear();
            return <Navigate to={"/"}/>;
        }
        sessionStorage.setItem("TriedAccessing", window.location.href);
        return <Navigate to="/login"/>;
    }

    if (portal) return null;

    return <>{children}</>;
};

export {NotLoggedInGuard};
